import { render, staticRenderFns } from "./KbSim.vue?vue&type=template&id=e84d5bfc&scoped=true&"
import script from "./KbSim.vue?vue&type=script&lang=js&"
export * from "./KbSim.vue?vue&type=script&lang=js&"
import style0 from "./KbSim.vue?vue&type=style&index=0&id=e84d5bfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84d5bfc",
  null
  
)

export default component.exports